import Swal, { SweetAlertIcon } from 'sweetalert2';


export const showAlert = (titleText = 'Something happened.', alertType) => {

  Swal.fire({
    timer: 3000,
    title: 'Error!',
    position: 'top-end',
    timerProgressBar: true,
    cancelButtonText: 'Dismiss',
    showCancelButton: false,
    showConfirmButton: false,
    titleText,
    icon: alertType,
    confirmButtonText: 'Cool',
    target: '#custom-target',
    customClass: {
      container: 'position-absolute'
    },
    toast: true,
    showClass: {
      popup: 'swal2-noanimation',
      backdrop: 'swal2-noanimation',
    },
    hideClass: {
      popup: '',
      backdrop: '',
    },
  })
};